import {
  SHIPPINGS_REQUEST, SHIPPINGS_REQUEST_SUCCESS, SHIPPINGS_REQUEST_FAILED
} from "../actions/shippings_actions";

const initialState = {
  shippings: [],
}

export const shippingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHIPPINGS_REQUEST: {
      return {
        ...state
      }
    }
    case SHIPPINGS_REQUEST_SUCCESS: {
      return {
        ...state,
        shippings: [...action.payload],
      }
    }
    case SHIPPINGS_REQUEST_FAILED: {
      return {
        ...state
      }
    }
    default: return state;
  }
}
